"use strict";

var _slicedToArray = require("/Users/carl.holloway/dev/rotaready/static-rotaready.com/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _useChat = _interopRequireDefault(require("../../hooks/useChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {
  container: {
    zIndex: 1,
    position: 'fixed',
    border: '0',
    width: '64px',
    height: '64px',
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 8px 16px 0px',
    left: 'auto'
  },
  button: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '64px',
    minWidth: '64px',
    height: '64px',
    minHeight: '64px',
    padding: '0',
    cursor: 'pointer',
    border: '0'
  },
  icon: {
    fontSize: '36px'
  }
};

var Userlike = function Userlike(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '#0d8cff' : _ref$backgroundColor,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'right' : _ref$position,
      _ref$vOffset = _ref.vOffset,
      vOffset = _ref$vOffset === void 0 ? '24px' : _ref$vOffset,
      _ref$hOffset = _ref.hOffset,
      hOffset = _ref$hOffset === void 0 ? '24px' : _ref$hOffset,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? 'round' : _ref$style;

  var _ref2 = (0, _useChat.default)({
    loadWhenIdle: true
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      state = _ref3[0],
      loadChat = _ref3[1];

  var positionStyles = {
    bottom: vOffset,
    right: position === 'left' ? 'auto' : hOffset,
    left: position === 'right' ? 'auto' : hOffset
  };
  var shapeStyle = {
    borderRadius: style === 'round' ? '50%' : '0'
  };

  if (state === 'complete') {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread(_objectSpread({}, styles.container), positionStyles), shapeStyle)
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return loadChat({
        open: true
      });
    },
    onMouseEnter: function onMouseEnter() {
      return loadChat({
        open: false
      });
    },
    style: _objectSpread(_objectSpread(_objectSpread({}, styles.button), shapeStyle), {}, {
      backgroundColor: backgroundColor
    })
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none",
    style: _objectSpread(_objectSpread({}, styles.icon), {}, {
      color: color
    })
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36c2.893 0 5.626-.682 8.047-1.895h5.11a2 2 0 002-2v-4.393A17.916 17.916 0 0036 18c0-9.941-8.059-18-18-18S0 8.059 0 18s8.059 18 18 18zM9.5 22a1.5 1.5 0 000 3h17a1.5 1.5 0 000-3h-17zm1.5-4a1.5 1.5 0 011.5-1.5h14a1.5 1.5 0 010 3h-14A1.5 1.5 0 0111 18zm-1.5-7a1.5 1.5 0 000 3h17a1.5 1.5 0 000-3h-17z",
    fill: "currentColor"
  }))));
};

var _default = Userlike;
exports.default = _default;